import ClawMachines from "./ClawMachines";
import Photobooth from "./Photobooth";
import ArtistAlley from "./ArtistAlley";
import Leaderboard from "./Leaderboard";
import GiftCards from "./GiftCards";
import Events from "./Events";
import Rentals from "./Rentals";
import Memberships from "./Memberships";
import { lazy } from "react";

// Lazy: PopUps pulls in @mui/x-date-pickers (~37 kB gzip) for the booking
// calendar — keep that out of the main bundle. ServiceDetails renders service
// content inside a <Suspense>.
const PopUps = lazy(() => import("./PopUps"));

export const SERVICE_COMPONENTS = {
  ClawMachines,
  Photobooth,
  ArtistAlley,
  Memberships,
  Leaderboard,
  GiftCards,
  Events,
  Rentals,
  PopUps,
};
